export async function dynamicUaParser<T>(
  callback: (UAParser: typeof import('ua-parser-js')) => T,
) {
  const UAParser = (await import('ua-parser-js')).default

  return await callback(UAParser)
}
